import { render, staticRenderFns } from "./BlogAuthorEdit.vue?vue&type=template&id=82f694bc&scoped=true&"
import script from "./BlogAuthorEdit.vue?vue&type=script&lang=js&"
export * from "./BlogAuthorEdit.vue?vue&type=script&lang=js&"
import style0 from "./BlogAuthorEdit.vue?vue&type=style&index=0&id=82f694bc&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f694bc",
  null
  
)

export default component.exports